import { call, put, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import {
  GET_PUBLIC_UNSUBSCRIBE_GROUPS_REQUEST,
  GET_UNSUBSCRIBE_PREFERENCE_REQUEST,
  CREATE_UNSUBSCRIBE_PREFERENCE_REQUEST,
  UPDATE_UNSUBSCRIBE_PREFERENCE_REQUEST,
  GetPublicUnsubscribeGroupsRequestAction,
  GetUnsubscribePreferenceRequestAction,
  CreateUnsubscribePreferenceRequestAction,
  UpdateUnsubscribePreferenceRequestAction,
} from './unsubscribePreference.types';
import {
  getPublicUnsubscribeGroupsSuccess,
  getPublicUnsubscribeGroupsFailure,
  getUnsubscribePreferenceSuccess,
  getUnsubscribePreferenceFailure,
  createUnsubscribePreferenceSuccess,
  createUnsubscribePreferenceFailure,
  updateUnsubscribePreferenceSuccess,
  updateUnsubscribePreferenceFailure,
} from './unsubscribePreference.action';
import {
  getPublicUnsubscribeGroups,
  getUnsubscribePreference,
  createUnsubscribePreference,
  updateUnsubscribePreference,
} from '../../services/unsubscribePreferenceService/unsubscribePreferenceService';

function* getPublicUnsubscribeGroupsSaga(
  action: GetPublicUnsubscribeGroupsRequestAction
): SagaIterator {
  try {
    const { trackingId } = action.payload;
    const response: any = yield call(getPublicUnsubscribeGroups, trackingId);
    yield put(getPublicUnsubscribeGroupsSuccess(response));
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch public unsubscribe groups';
    yield put(getPublicUnsubscribeGroupsFailure(errorMessage));
  }
}

function* getUnsubscribePreferenceSaga(
  action: GetUnsubscribePreferenceRequestAction
): SagaIterator {
  try {
    const { trackingId } = action.payload;
    const response: any = yield call(getUnsubscribePreference, trackingId);
    yield put(getUnsubscribePreferenceSuccess(response));
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch unsubscribe preference';
    yield put(getUnsubscribePreferenceFailure(errorMessage));
  }
}

function* createUnsubscribePreferenceSaga(
  action: CreateUnsubscribePreferenceRequestAction
): SagaIterator {
  try {
    const { trackingId, data } = action.payload;
    const response: any = yield call(
      createUnsubscribePreference,
      trackingId,
      data
    );
    yield put(createUnsubscribePreferenceSuccess(response));
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to create unsubscribe preference';
    yield put(createUnsubscribePreferenceFailure(errorMessage));
  }
}

function* updateUnsubscribePreferenceSaga(
  action: UpdateUnsubscribePreferenceRequestAction
): SagaIterator {
  try {
    const { trackingId, data } = action.payload;
    const response: any = yield call(
      updateUnsubscribePreference,
      trackingId,
      data
    );
    yield put(updateUnsubscribePreferenceSuccess(response));
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to update unsubscribe preference';
    yield put(updateUnsubscribePreferenceFailure(errorMessage));
  }
}

export function* unsubscribePreferenceSaga(): SagaIterator {
  yield takeLatest(
    GET_PUBLIC_UNSUBSCRIBE_GROUPS_REQUEST,
    getPublicUnsubscribeGroupsSaga
  );
  yield takeLatest(
    GET_UNSUBSCRIBE_PREFERENCE_REQUEST,
    getUnsubscribePreferenceSaga
  );
  yield takeLatest(
    CREATE_UNSUBSCRIBE_PREFERENCE_REQUEST,
    createUnsubscribePreferenceSaga
  );
  yield takeLatest(
    UPDATE_UNSUBSCRIBE_PREFERENCE_REQUEST,
    updateUnsubscribePreferenceSaga
  );
}
